
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/setup",
      function () {
        return require("private-next-pages/android/setup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/setup"])
      });
    }
  